import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const rulerTool: Tool = {
  id: "ruler",
  name: () => m.ruler_tool_name(),
  description: () => m.ruler_tool_description(),
  icon: "📏",
  basePath: "/ruler",
  status: "stable",
  tags: ["ruler", "measure", "actual-size", "cm", "inches", "everyday"],
};
